import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { AzureBlobCopySource } from 'app/model/pipeline/copysource/azure-blob.copysource';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { FileTypeSourceAdapter } from 'app/model/adapters/activities/copysource/file-type.source.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureBlobCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        recursive: '*',
        maxConcurrentConnections: '*'
    }
})
export class AzureBlobCopySourceAdapter extends CopySourceAdapter<AzureBlobCopySource, Model.BlobSource> {
    protected override async _toResource(copySource: AzureBlobCopySource): Promise<Model.BlobSource> {
        const result: Model.BlobSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(AzureBlobCopySource).name
        );
        FileTypeSourceAdapter.toSourceResource(copySource, result);
        return result;
    }

    protected override async _toModel(
        blobSource: Model.BlobSource,
        copyActivity: CopyActivity
    ): Promise<AzureBlobCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            AzureBlobCopySource.MODEL,
            blobSource,
            copyActivity
        ) as AzureBlobCopySource;
        FileTypeSourceAdapter.toSourceModel(blobSource, result);
        return result;
    }
}
